// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vant from 'vant';
import 'vant/lib/index.css';

//引入兼容
import 'babel-polyfill'

import App from './App'
import router from './router'
import Vuex from 'vuex';
import ElementUI from 'element-ui';

ElementUI.Dialog.props.closeOnClickModal.default = false
import 'babel-polyfill';//支持IE执行原生script

import 'normalize.css/normalize.css';// normalize.css 样式格式化
import 'element-ui/lib/theme-chalk/index.css';
import './assets/custom-theme/index.css'; // 换肤版本element-ui css
import './css/common.css'; // 换肤版本element-ui css
import md5 from 'js-md5';
import NProgress from 'nprogress'; // Progress 进度条
import 'nprogress/nprogress.css';// Progress 进度条 样式

// import 'assets/iconfont/iconfont'; // iconfont 具体图标见https://github.com/PanJiaChen/vue-element-admin/wiki
// import Multiselect from 'vue-multiselect';// 使用的一个多选框组件，element-ui的select不能满足所有需求
// import 'vue-multiselect/dist/vue-multiselect.min.css';// 多选框组件css
// import Sticky from 'components/Sticky'; // 粘性header组件
// import IconSvg from 'components/Icon-svg';// svg 组件
import vueWaves from './directive/waves';// 水波纹指令
// import errLog from 'store/errLog';// error log组件

import store from './store';
import {getKey, setKey, setKeyExpire, getUserInfoByUserId} from './api/loginApi/loginAx';
import config from "../config/config";

import Cookies from 'js-cookie'
import echarts from 'echarts'
import axios from 'axios';
import { getToken } from './util/auth';
import './css/kyxm-list.css'; // 科研模块列表/弹窗统一样式
import Video from 'video.js'
import 'video.js/dist/video-js.css'


// import Vue from 'vue';
// import AMap from 'vue-amap';

// AMap.initAMapApiLoader({
//   key: '5a15ebfcdd26f3c6e240a8bb015b9b43',
//   plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
//   // 默认高德 sdk 版本为 1.4.4
//   v: '1.4.4'
// });


Vue.prototype.$video = Video

Vue.prototype.$echarts = echarts
Vue.use(vueWaves);
Vue.use(ElementUI)
Vue.use(Vuex);
Vue.use(Vant);

// 全局 axios 拦截器：所有请求统一携带 token（供直接使用 axios 的导出、上传等接口）
axios.interceptors.request.use(config => {
  const token = localStorage.getItem("code") || getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers["X-Auth-Code"] = token;
  }
  return config;
}, err => Promise.reject(err));

//消息提示  1成功 0 危险 2 警告
Vue.prototype.$msg = (type, title, time) => {
  let t = ""; //默认消息
  let duration = (time == null || time == undefined) ? 3000 : time
  if (type == 1) {
    t = "success";
    if (title == null || title == undefined) {
      title = "操作成功！";
    }
    // title = "操作成功！";
  } else if (type == 2) {
    t = "warning";
    if (title == null || title == undefined) {
      title = "操作失败！";
    }
    // title = "操作失败！";
  } else if (type == 0) {
    t = "error";
    if (title == null || title == undefined) {
      title = "操作失败！";
    }
    // title = "操作失败！";
  }
  Vue.prototype.$message({
    message: title,
    type: t,
    duration: duration,
  });
},

  // 本地开发
  // localStorage.setItem("No", "RJ695")
  // localStorage.setItem("Name", "曾垂城")
  // localStorage.setItem("code", "Uigvge6liDzjeuc414q35hbJ0cjOkDoJFOrl")
  // localStorage.setItem("FK_Dept", "00200100");
  // localStorage.setItem("FK_DeptName", "信息管理中心");
  // localStorage.setItem("Type", "1");
  // localStorage.setItem('userId', "RJ695");
  // localStorage.setItem('role', "[1]");
  // store.dispatch('getMenus');
  // store.dispatch('getButtons');

// // ********************************************************** */
// 截取url中的数据

// 部署正式 打开注释
localStorage.removeItem("TC");
let tempStr = window.location.href;
let tempArr = tempStr.split('?')[1] ? tempStr.split('?')[1].split('&') : []
let returnArr = {}
var that = this;
tempArr.forEach(element => {
  returnArr[element.split('=')[0]] = element.split('=')[1]
})
let code = returnArr.code
let newsId = returnArr.newsId
let tag = returnArr.tag
let usid = returnArr.usid

console.log(tempStr)
console.log(tempArr)
console.log(returnArr)

if (!usid) {
  console.log("usid is empty");
  if (!code) {
    console.log("code is empty, retrieving from localStorage");
    code = localStorage.getItem("code");
  }
  if (code) {
    let cs = { "key": code };
    getKey(cs).then(res => {
      if (res.data.outmap.result) {
        let userId = res.data.outmap.result;
        console.log("userId:" + userId)
        if (userId) {
          let cs = { userId: userId };
          getUserInfoByUserId(cs).then(res => {
            if (res.data.outmap.result === 1 && res.data.outmap.userMap) {
              let user = res.data.outmap.userMap;
              let role = res.data.outmap.role
              console.log("user:" + user)
              if (user.NAME) {
                localStorage.setItem("code", code);
                localStorage.setItem("No", user.NO);
                localStorage.setItem("Name", user.NAME);
                localStorage.setItem("FK_Dept", user.FK_Dept);
                localStorage.setItem("FK_DeptName", user.FK_DeptName);
                localStorage.setItem("Type", user.Type);
                localStorage.setItem('userId', user.NO);
                localStorage.setItem('role', JSON.stringify(role));
                store.dispatch('getMenus');
                store.dispatch('getButtons');
              } else {
                clearLocalStorage();
                redirectToLogin();
              }
            } else {
              clearLocalStorage();
              redirectToLogin();
            }
          });
        } else {
          clearLocalStorage();
          redirectToLogin();
        }
      } else {
        clearLocalStorage();
        redirectToLogin();
      }
    });
  } else {
    clearLocalStorage();
    redirectToLogin();
  }
} else {
  let userId = usid
  if (userId) {
    let cs = { userId: userId };
    getUserInfoByUserId(cs).then(res => {
      if (res.data.outmap.result === 1 && res.data.outmap.userMap) {
        let user = res.data.outmap.userMap;
        let role = res.data.outmap.role
        if (user.NAME) {
          localStorage.setItem("code", code);
          localStorage.setItem("No", user.NO);
          localStorage.setItem("Name", user.NAME);
          localStorage.setItem("FK_Dept", user.FK_Dept);
          localStorage.setItem("FK_DeptName", user.FK_DeptName);
          localStorage.setItem("Type", user.Type);
          localStorage.setItem('userId', user.NO);
          localStorage.setItem('role', JSON.stringify(role));
          store.dispatch('getMenus');
          store.dispatch('getButtons');
        } else {
          clearLocalStorage();
          redirectToLogin();
        }
      } else {
        clearLocalStorage();
        redirectToLogin();
      }
    });
  } else {
    clearLocalStorage();
    redirectToLogin();
  }
}

function clearLocalStorage() {
  localStorage.removeItem("code");
  localStorage.removeItem("No");
  localStorage.removeItem("Name");
  localStorage.removeItem("FK_Dept");
  localStorage.removeItem("FK_DeptName");
  localStorage.removeItem("Type");
  localStorage.removeItem("userId");
}

function redirectToLogin() {
  location.replace(config.apiUrl+'/sso/glLogin');
}




Vue.config.productionTip = false;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

// let cs = {
//   ZGH : localStorage.getItem("userId"), //职工号
//   ZHXM : localStorage.getItem("Name"),//职工姓名
//   KHD : localStorage.getItem("FK_Dept"),//客户端类型
//   CZNR : "后台登录",
// }
// insertNote(cs).then((res) => {
//   console.log(res)
//   if(res == false){
//     console.log("日志插入失败(后台登录)")
//   }
// })
//   .catch(() => {
//   });



// WEBPACK FOOTER //
// ./src/main.js